import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "./LoginStyle.css"

interface Props{
    setloggedState: React.Dispatch<React.SetStateAction<number>>;
    setloggedID: React.Dispatch<React.SetStateAction<string>>;
    setTag: React.Dispatch<React.SetStateAction<string>>;
    setName: React.Dispatch<React.SetStateAction<string>>;
    setToken: React.Dispatch<React.SetStateAction<string>>;
    setAccountStatus: React.Dispatch<React.SetStateAction<string>>;
    setTestAlarms: React.Dispatch<React.SetStateAction<number>>;
    setAGBStatus: React.Dispatch<React.SetStateAction<number>>;
    setDSGVOStatus: React.Dispatch<React.SetStateAction<number>>;
    setUseCondStatus: React.Dispatch<React.SetStateAction<number>>;
    setAlarmMonitorURL: React.Dispatch<React.SetStateAction<string>>;
}

const Login = ({setloggedState, setloggedID, setTag, setName, setToken, setAccountStatus,setTestAlarms,setAGBStatus,setDSGVOStatus,setUseCondStatus,setAlarmMonitorURL}:Props) => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [passwordVisible, setPasswordVisible] = useState(false);
    
    const navigate = useNavigate();
        

    const onSignInClick = () => {
      navigate("/SignIn")
    }

    const onForgetPasswordClick = () => {
      navigate("/ForgetPassword")
    }

    const onButtonClick = () => {
        // Set initial error values to empty
        setEmailError("")
        setPasswordError("")

        // Check if the user has entered both fields correctly
        if ("" === email) {
            setEmailError("Bitte Benutzernamen eingeben")
            return
        }

        if ("" === password) {
            setPasswordError("Bitte Passwort eingeben")
            return
        }

        if (password.length < 7) {
            setPasswordError("Das Passwort muss mindestens 8 Zeichen lang sein")
            return
        }

        handleLogin(email, password);
    }

    const isValidDate = (dateString: string) => {
      // Prüfen, ob der Date-String geparst werden kann und ein gültiges Datum ergibt
      const parsedDate = Date.parse(dateString);
      return !isNaN(parsedDate);
    };

    const handleLogin = async (username:string, password: string) => {
        try {
            setloggedState(0);
          const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/LoginHandler.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              username,
              password,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            //console.log('Erfolgreich eingeloggt:', data);
            //console.log('tag:', data['tag']);
            const payStatus = data['accountStatus'];
            const testAlarms = data['testAlarms'];
            const testAlarmsInt = parseInt(data['testAlarms']);
            setAGBStatus(parseInt(data['agbStatus']))
            setDSGVOStatus(parseInt(data['dsgvoStatus']))
            setUseCondStatus(parseInt(data['useCondStatus']))
            setAlarmMonitorURL(data['alarmMonitorURL'])
            //console.log(payStatus);
            if(payStatus != 'Payed' ){
              if(isValidDate(payStatus)){
                const date = new Date(payStatus)
                if(date >= new Date()){
                  setTag(data['tag'])
                  setName(data['name'])
                  setToken(data['token'])
                  setAccountStatus(data['accountStatus'])
                  setTestAlarms(testAlarms)
                  setloggedState(1)
                  setloggedID(data['loggedID'])
                  navigate("/MainPage")
                }
                else {
                  setTag(data['tag'])
                  setName(data['name'])
                  setToken(data['token'])
                  setloggedID(data['loggedID'])
                  navigate("/PayPage") 
                }
              }
              else {
                if(payStatus==='Test'){
                  if(testAlarmsInt > 0){
                    setTag(data['tag'])
                    setName(data['name'])
                    setToken(data['token'])
                    setAccountStatus(data['accountStatus'])
                    setTestAlarms(testAlarms)
                    setloggedState(1);
                    setloggedID(data['loggedID'])
                    navigate("/MainPage")
                  } else{
                    setTag(data['tag'])
                    setName(data['name'])
                    setToken(data['token'])
                    setloggedID(data['loggedID'])
                    navigate("/PayPage")
                  }
                } 
                else{
                  setTag(data['tag'])
                  setName(data['name'])
                  setToken(data['token'])
                  setloggedID(data['loggedID'])
                  navigate("/PayPage")
                }
              }
            }
            else {
              setTag(data['tag'])
              setName(data['name'])
              setToken(data['token'])
              setloggedState(1);
              setloggedID(data['loggedID'])
              setAccountStatus(data['accountStatus'])
              setTestAlarms(testAlarms)
              navigate("/MainPage")
            }
          } else {
            const data = await response.json();
            //console.log(data);
            //console.error('Fehler beim Einloggen:', response.statusText);
            setPasswordError("Falscher Benutzername oder Passwort")
          }
        } catch (error) {
          //console.error('Fehler beim Einloggen:', error);
          setPasswordError("Falscher Benutzername oder Passwort")
        }
      };

    const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
    };

    return <div className="mainContainer">
        <div className="titleContainer">
            <h2>Junior Alarm Login</h2>
        </div>
        <br />
        <div className="inputContainer">
          <label>Benutzername:</label>
            <input
                value={email}
                placeholder="Benutzernamen eingeben"
                onChange={ev => setEmail(ev.target.value)}
                className="inputBox" />
            <label className="errorLabel">{emailError}</label>
        </div>
        <br />
        <div className={"inputContainer"}>
        <label>Passwort:</label>
          <div className="passwordContainer">
            <input
              className='inputBox'
              placeholder='Passwort eingeben'
              type={passwordVisible ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FontAwesomeIcon
              icon={passwordVisible ? faEyeSlash : faEye}
              onClick={togglePasswordVisibility}
              className="passwordIcon"
            />
          </div>
          <label className="errorLabel">{passwordError}</label>
        </div>
        <div>
          <input
            className="forgotPasswordButton"
            type="button"
            onClick={onForgetPasswordClick}
            value={"Passwort vergessen"} />
        </div>

        <br />
        <div className="inputContainer">
            <input
                className="inputButton"
                type="button"
                onClick={onButtonClick}
                value={"Anmelden"} />
        </div>
        <div>
          <input
            className="forgotPasswordButton"
            type="button"
            onClick={onSignInClick}
            value={"Registrieren"} />
        </div>
    </div>
}

export default Login
